import type { RouteLocationNormalizedLoaded, Router } from "vue-router"
import { searchStore } from "@/store/search"
import { Job } from "@/store/jobs"

export function navigateToJob(
    job: Job,
    route: RouteLocationNormalizedLoaded,
    router: Router
) {
    let target: { type: "client" | "project"; id: number } | null = null
    if (job.Project?.Id) {
        target = { type: "project", id: job.Project.Id }
    } else {
        const firstClientId = job.Clients?.[0]?.Id
        if (firstClientId && firstClientId !== 1) {
            target = { type: "client", id: firstClientId }
        }
    }
    if (!target) return

    searchStore().requestJobNavigation({
        type: target.type,
        entityId: target.id,
        jobId: job.Id,
    })

    const alreadyThere =
        route.query.page === target.type && Number(route.query.id) === target.id
    if (!alreadyThere) {
        router.push({
            query: { ...route.query, page: target.type, id: String(target.id) },
        })
    }
}
